/**
 * Get image source URL - handles both base64 and file URLs
 * @param {string} imageData - Either base64 string or URL path
 * @returns {string} - Proper image src value
 */
export const getImageSrc = (imageData) => {
  if (!imageData) return '';
  
  // If it's already a URL (starts with http://, https://, or /), use it as-is
  if (imageData.startsWith('http://') || 
      imageData.startsWith('https://') || 
      imageData.startsWith('/')) {
    return imageData;
  }
  
  // If it's already a data URI, use it as-is
  if (imageData.startsWith('data:')) {
    return imageData;
  }
  
  // Otherwise, it's base64 data - wrap it
  return `data:image/jpeg;base64,${imageData}`;
};
